import styles from "./MatrixProperties.module.css";
import "ml-matrix";
import PropertiesBox from "../../components/propertiesBox/PropertiesBox";
import React from "react";

const MatrixProperties = () => {

    return (
        <div className={styles.page_wrapper}>
            <div className={styles.header_wrapper}>
                <h1 className={styles.title}>
                    Matrix <span id={styles.keyword}>Properties</span>
                </h1>
            </div>
            <div className={styles.body_wrapper}>
                <PropertiesBox/>
            </div>
        </div>
    );
};

export default MatrixProperties;